import * as Yup from 'yup';

export interface ICalculationStatementUpdate {
  status?: number;
  rate?: number;
  deleted?: boolean;
  transfer?: string;
  service?: string;
  debitDate?: string;
  paymentDate?: string;
  originalAmount?: number;
  originalCurrencyId?: number;
  finalAmount?: number;
  finalCurrencyId?: number;
  payedAmount?: number;
  payedCurrencyId?: number;
  description?: string;
}

export const StatementSchema = Yup.object().shape({
  debitDate: Yup.string().required('Required'),
  paymentDate: Yup.string().nullable(),
  originalAmount: Yup.number().required('Required'),
  originalCurrencyId: Yup.string().required('Required'),
  finalAmount: Yup.number().nullable(),
  finalCurrencyId: Yup.string().nullable(),
  payedAmount: Yup.number().nullable(),
  payedCurrencyId: Yup.string().nullable(),
  transfer: Yup.string().required('Required'),
  status: Yup.number().nullable(),
  rate: Yup.number().nullable(),
  service: Yup.string().required('Required'),
  description: Yup.string().trim().required('Required'),
});
